import Termly from 'termly-namespace'

import ConsentDefaults from 'constants/consentDefaults'

import GTM from 'utils/gtm'
import WP from 'utils/wp'

import enableConsentScripts from 'utils/enableConsentScripts'


export default function releaseResources({ sendConsentUpdate }) {
  console.debug('[Termly] Releasing resources')

  // Where we release resources, no consent UI appears and nothing stays
  // blocked. Termly is still on the page, though, and it still reports the
  // region's standing consent state. Manually-blocked scripts are why we
  // can't simply bow out here: we are the only thing that can release those.
  enableConsentScripts()

  // Record the granted state as Termly's default consents so consent lookups
  // reflect it. This has to happen before we notify below, or GTM won't store
  // the consents we send.
  Termly.setDefaultConsents(ConsentDefaults.OPT_OUT)

  if ( sendConsentUpdate ) {
    GTM.send(ConsentDefaults.OPT_OUT)
  } else {
    // A region with the banner disabled never asks the visitor anything, so
    // there is no decision to report as a consent update, and the granted
    // default we sent earlier stands on its own. The "consent saved" events
    // still have to go out: they are in our public documentation, and customer
    // tag managers release their own tags on them.
    GTM.sendDone(ConsentDefaults.OPT_OUT)
  }

  WP.send(ConsentDefaults.OPT_OUT)
}
